import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { segmentsQueryKeys } from "./queryKeys";

import { campaignQueryKeys } from "@/features/campaigns/api/queryKeys";
import { instance } from "@/lib/axios/instance";
import type { ProblemDetails } from "@/lib/helpers/handleProblemDetailsError";

type ArchiveSegmentVariables = {
  segmentId: string;
  clientId?: string;
};

export function useArchiveSegment() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<ProblemDetails>, ArchiveSegmentVariables>(
    {
      mutationFn: async ({ segmentId, clientId }) => {
        await instance.post(`/api/v2/Segments/${segmentId}/archive`, null, {
          params: clientId ? { clientId } : {},
        });
      },
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: segmentsQueryKeys.all,
        });
        void queryClient.invalidateQueries({
          queryKey: campaignQueryKeys.all,
        });
      },
    },
  );
}
